import { render } from "./DiscardIcon.vue?vue&type=template&id=6c8aa703"
import script from "./DiscardIcon.vue?vue&type=script&lang=js"
export * from "./DiscardIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__